import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M4 4.375a1.625 1.625 0 1 0 0 3.25 1.625 1.625 0 0 0 0-3.25Zm5 1a.625.625 0 1 0 0 1.25h12a.625.625 0 1 0 0-1.25H9Zm-5 5a1.625 1.625 0 1 0 0 3.25 1.625 1.625 0 0 0 0-3.25Zm5 1a.625.625 0 1 0 0 1.25h12a.625.625 0 1 0 0-1.25H9Zm-5 5a1.625 1.625 0 1 0 0 3.25 1.625 1.625 0 0 0 0-3.25Zm5 1a.625.625 0 1 0 0 1.25h12a.625.625 0 1 0 0-1.25H9Z"
    />
  </svg>
`;
